// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageCard_wrapper__pethE"};